var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.scope + ':' + _vm.modern,staticClass:"follow-compat-shell"},[_c('keep-alive',[_c(_vm.modern ? 'Modern' : 'Legacy',{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }